import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TexteService } from 'src/app/core/services/texte.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { RefDto, ApiService } from 'src/app/core/services/api.service';
import { ToolboxService } from 'src/app/core/services/toolbox.service';
import { IHistorique } from 'src/app/core/interfaces/historique.interface';

@Component({
    selector: 'app-historique-form',
    templateUrl: './historique-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HistoriqueFormComponent implements OnInit {

    public historiqueForm: FormGroup;
    public conditions: RefDto[];
    public conditionsSelected: RefDto[];

    constructor(
        public texteService: TexteService,
        private apiService: ApiService,
        private toolboxService: ToolboxService
    ) { }

    ngOnInit(): void {
        this.conditionsSelected = [];
        this.apiService.getConditions().subscribe(data => {
            this.conditions = data;
        });
        this.buildForm();
    }

    private buildForm() {
        this.historiqueForm = new FormGroup({
            taille: new FormControl('', Validators.required),
            poid: new FormControl('', Validators.required),
            fume: new FormControl('', Validators.required),
            alcool: new FormControl('', Validators.required),
            infection: new FormControl(''),
        });
    }

    public isValid(): boolean {
        return this.historiqueForm.valid;
    }

    public getForm(): IHistorique {
        return {
            taille: this.historiqueForm.get('taille').value,
            poid: this.historiqueForm.get('poid').value,
            fume: this.historiqueForm.get('fume').value,
            alcool: this.historiqueForm.get('alcool').value,
            infection: this.historiqueForm.get('infection').value,
            conditions: this.conditionsSelected
        } as IHistorique;
    }

    onConditionsChanged(event, condition: RefDto) {
        if (event.checked) {
            this.conditionsSelected = this.toolboxService.arrayInsert(this.conditionsSelected, condition);
        } else {
            this.conditionsSelected = this.toolboxService.arrayRemove(this.conditionsSelected, condition);
        }
    }
}
